import type { FC } from "react";

import { NavRow } from "@/components/ui/nav-row";
import { paneTitleClass } from "@/components/ui/pane-header";

import { useCaseCompany } from "../../companies/queries";
import { useCaseIde } from "../context/CaseIdeContext";
import { artifactKey } from "../types";

/** The explorer's Company row: opens the case's Company tab. Shown only for linked cases. */
export const CompanyHeader: FC<{ individualId: string }> = ({
  individualId
}) => {
  const { activeKey, open } = useCaseIde();
  const { data } = useCaseCompany(individualId);
  if (!data?.company) return null;
  const active =
    activeKey === artifactKey({ kind: "company", id: individualId });

  return (
    <NavRow
      data-testid="company-header"
      active={active}
      onClick={() =>
        open({
          kind: "company",
          id: individualId,
          title: data.company?.name ?? "Company"
        })
      }
      trailing={
        <span className="max-w-32 truncate text-fg-3">{data.company.name}</span>
      }
    >
      <span className={paneTitleClass}>Company</span>
    </NavRow>
  );
};
